( function () {
    'use strict';
    function zeroPad(num, places) {
        var zero = places - num.toString().length + 1;
        return Array(+(zero > 0 && zero)).join("0") + num;
    }    
    ( function ( $ ) {
        $('.portfolio-slick').on('init', function(event, slick) {
            $('.pc-counter .current').text(zeroPad(slick.currentSlide + 1,2));
            $('.pc-counter .total').text(zeroPad(slick.slideCount,2));
        });
        $('.portfolio-slick').slick({
            slideToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 3000,
            infinite: true,
            arrows: true,
            fade: true,
            rows: 0,
            prevArrow: $('.pc-prev'),
            nextArrow: $('.pc-next'),
        })
        .on('beforeChange', function(event, slick, currentSlide, nextSlide) {
            $('.pc-counter .current').text(zeroPad(nextSlide + 1,2));
        });
    } )( jQuery );
} )();